import { useEffect } from 'react';
import { AuctionDto } from '../../../services/Auction/auctionService.dto';
import { dateUtils } from '../../../utils/dateUtils';

const DELAY_IN_MS = 1000;

export const useAuctionEndDetection = (auction?: AuctionDto, onAuctionExpired?: () => void) => {
  useEffect(() => {
    if (auction && onAuctionExpired) {
      const endDateTime = dateUtils.parseBackendDate(auction.endDateTime);
      const currentDateTime = dateUtils.currentDate();
      const plannedEnd = endDateTime.getTime() - currentDateTime.getTime();

      if (plannedEnd > 0 && plannedEnd < Number.MAX_SAFE_INTEGER) {
        const timeout = setTimeout(onAuctionExpired, plannedEnd + DELAY_IN_MS);
        return () => clearTimeout(timeout);
      }
    }
  }, [auction, onAuctionExpired]);
};
